import { create } from 'zustand';
import fundraisingService from '../api/services/fundraising.service';

/* Donations and expenses are API-backed per network (shared by Fundraising +
   Dashboard). Each list pulls everything active for the network (the API pages
   at `limit`, so loop until done), cached per network — pass force to refetch
   after writes. */
const useFundraisingStore = create((set, get) => ({
  donations: [],
  donationsLoading: false,
  donationsNetworkId: null,
  expenses: [],
  expensesLoading: false,
  expensesNetworkId: null,

  loadDonations: async (networkId, { force = false } = {}) => {
    if (!networkId) return;
    if (!force && get().donationsNetworkId === networkId) return;
    set({ donationsLoading: true });
    try {
      const first = await fundraisingService.listDonations(networkId, { page: 1, limit: 100, status: 'active' });
      let all = first.donations;
      for (let p = 2; p <= Math.min(first.totalPages, 20); p++) {
        const next = await fundraisingService.listDonations(networkId, { page: p, limit: 100, status: 'active' });
        all = all.concat(next.donations);
      }
      set({ donations: all, donationsNetworkId: networkId });
    } finally {
      set({ donationsLoading: false });
    }
  },

  loadExpenses: async (networkId, { force = false } = {}) => {
    if (!networkId) return;
    if (!force && get().expensesNetworkId === networkId) return;
    set({ expensesLoading: true });
    try {
      const first = await fundraisingService.listExpenses(networkId, { page: 1, limit: 100, status: 'active' });
      let all = first.expenses;
      for (let p = 2; p <= Math.min(first.totalPages, 20); p++) {
        const next = await fundraisingService.listExpenses(networkId, { page: p, limit: 100, status: 'active' });
        all = all.concat(next.expenses);
      }
      set({ expenses: all, expensesNetworkId: networkId });
    } finally {
      set({ expensesLoading: false });
    }
  },
}));

export const fundTotals = (donations, expenses) => {
  const raised = donations.reduce((sum, d) => sum + Number(d.amount), 0);
  const spent = expenses.reduce((sum, e) => sum + Number(e.amount), 0);
  return { raised, spent, balance: raised - spent };
};

export default useFundraisingStore;
